import BaseProductSearchPageMixin from "@/modules/core/product/protected/BaseProductSearchPageMixin";
import SearchParametersEditor from "./CreditAssignmentProductSearchParametersEditor";
import service from "./CreditAssignmentProductService";

export default {
  mixins: [BaseProductSearchPageMixin],

  components: {
    SearchParametersEditor
  },

  props: {
    columns: {
      default() {
        return [
          {
            key: "name",
            label: this.$t("product.fields.name"),
            sortBy: "name",
            onClick: ({ row }) => {
              this.$router.push({
                name: "CreditAssignmentProduct",
                params: { id: row.id }
              });
            }
          },
          {
            key: "provider",
            label: this.$t("product.fields.provider"),
            sortBy: "provider.companyName",
            value: ({ row }) => row.provider.companyName
          },
          {
            key: "discountFactor",
            label: this.$t("creditAssignmentProduct.fields.discountFactor"),
            sortBy: "discountFactor",
            value: ({ row }) =>
              this.$number2text(row.discountFactor * 100) + "%"
          }
          /*
          {
            key: 'lastModified',
            label: this.$t('common.lastModified'),
            sortBy: 'lastModified'
          },
          */
        ];
      }
    }
  },

  methods: {
    getService() {
      return service;
    }
  }
};
